import { View, Text } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';

export default function StatCard({ label, value, subtitle, icon = 'analytics', tone = 'cyan' }) {
  const tones = {
    cyan: ['#cffafe', '#0891b2'],
    green: ['#dcfce7', '#16a34a'],
    red: ['#fee2e2', '#dc2626'],
    amber: ['#fef3c7', '#d97706'],
    indigo: ['#e0e7ff', '#4f46e5'],
  };
  const [bg, fg] = tones[tone] || tones.cyan;

  return (
    <View className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <View className="flex-row items-start justify-between">
        <Text className="max-w-[75%] text-xs font-semibold uppercase text-slate-500">{label}</Text>
        <View className="h-9 w-9 items-center justify-center rounded-full" style={{ backgroundColor: bg }}>
          <MaterialIcons name={icon} size={19} color={fg} />
        </View>
      </View>
      <Text className="mt-3 text-2xl font-bold text-slate-950">{value}</Text>
      {subtitle ? <Text className="mt-1 text-sm text-slate-500">{subtitle}</Text> : null}
    </View>
  );
}
